<template lang="pug">
.written-feedback-container
  p.rating-form_title(tabindex="0")
    | {{ feedbackText }}
  .rating-form_message(:contenteditable="messageEditable",
                      :placeholder="getString('screen.postchat_survey.optional', 'Optional')",
                      :class="{ 'disabled': isRated }"
                      @input="onInput")

  button.form_submit(type="button"
                    :disabled="isRated || selectedIndex == null"
                    @click="onSubmit") {{ getString('screen.postchat_survey.submit', 'Submit') }}
</template>

<script>
import i18n from '../../mixins/i18n';

const MIN_FORM_HEIGHT = 44;

export default {
  name: 'writtenFeedback',
  mixins: [i18n],
  props: {
    isRated: {
      type: Boolean,
      default: false,
    },
    selectedIndex: {
      type: Number,
    },
    feedbackText: {
      type: String,
      default: 'Thanks',
    },
  },
  data() {
    return {
      comments: null,
    };
  },
  computed: {
    messageEditable() {
      return this.selectedIndex > -1 && !this.isRated;
    },
  },
  methods: {
    checkHeight() {
      const form = document.querySelector('.form');
      if (form && form.offsetHeight > MIN_FORM_HEIGHT) {
        this.$emit('scrollToEnd');
      }
    },
    onInput(event) {
      if (event.target.disabled) {
        return false;
      }
      this.comments = event.target.innerText;
      this.checkHeight();
      return true;
    },
    onSubmit() {
      this.$emit('submit', this.comments);
    },
  },
};
</script>

<style lang="scss" scoped>
.rating-form_title {
  margin: 0;
  color: #67737F;
  font-size: 14px;
  line-height: 19px;
  text-align: center;
}

.form_submit {
  display: block;
  width: 100%;
  margin-bottom: 5px;
  height: 22px;
  color: rgba(26, 172, 253, 1);
  font-size: 14px;
  line-height: 19px;
  text-align: center;
  border: 1px solid #1AACFD;
  border-radius: 4px;
  background-color: #FFFFFF;
  outline: none;
  cursor: pointer;

  &[disabled] {
    color: #E5E9F2;
    border-color: #E5E9F2;
    cursor: default;
  }
}

.rating-form_message {
  display: block;
  width: calc(100% - 12px);
  min-width: calc(100% - 12px);
  max-width: calc(100% - 12px);
  min-height: 44px;
  padding: 7px 10px;
  margin: 10px auto 16px;
  font-size: 12px;
  line-height: 14px;
  border: 1px solid #BFCBD9;
  border-radius: 4px;
  background-color: #fff;
  box-sizing: border-box;
  outline: none;
  overflow: hidden;
  text-align: initial;

  &.disabled {
    color: #A6A6A6;
    border-color: #ccc;
    background-color: #E5E9F2;
  }

  &::before {
    color: #BFCBD9;
    font-size: 12px;
    line-height: 14px;
  }
}
</style>
